export const IconPaymentSuccess: React.FC = () => (
  <svg
    width="120"
    height="120"
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 60C0 26.8629 26.8629 0 60 0C93.1371 0 120 26.8629 120 60C120 93.1371 93.1371 120 60 120C26.8629 120 0 93.1371 0 60Z"
      fill="#F3F5F8"
    />
    <g clipPath="url(#clip0_22300_4081)">
      <path
        d="M45.3718 46.4866H36.3515C32.6184 46.4866 29.5947 49.5102 29.5947 53.2433V83.6487C29.5947 87.3818 32.6184 90.4055 36.3515 90.4055H83.6488C87.3819 90.4055 90.4055 87.3818 90.4055 83.6487V53.2433C90.4055 49.5102 87.3819 46.4866 83.6488 46.4866H74.6285"
        stroke="#0B564C"
        strokeWidth="4.05405"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M60.0001 59.1554C51.838 59.1554 45.2197 52.5372 45.2197 44.375C45.2197 36.2128 51.838 29.5946 60.0001 29.5946C68.1657 29.5946 74.7805 36.2128 74.7805 44.375C74.7805 52.5372 68.1657 59.1554 60.0001 59.1554Z"
        stroke="#0B564C"
        strokeWidth="4.05405"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M65.4418 41.6556L58.6377 48.4597L54.5566 44.3752"
        stroke="#0B564C"
        strokeWidth="4.05405"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.1084 76.892H56.6219"
        stroke="#0B564C"
        strokeWidth="4.05405"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_22300_4081">
        <rect
          width="81.0811"
          height="81.0811"
          fill="white"
          transform="translate(19.459 19.4595)"
        />
      </clipPath>
    </defs>
  </svg>
);
